import { EmbeddedgetAPI, EmbeddedPostAPI, getAPI, postAPI, putAPI } from "../../api/api"
import { REACT_APP_CONTRACTSIGN } from "../../utils/common"


// export async function DropboxPreview(body: any) {
//     const Details = EmbeddedPostAPI('https://api.hellosign.com/v3/signature_request/create_embedded_with_template', body)
//     return Details
// }

export async function DropboxPreview(body: any) {
    const Details = EmbeddedPostAPI('https://api.hellosign.com/v3/unclaimed_draft/create_embedded_with_template', body)
    return Details
}

export async function getSignedURl(signId: string) {
    const Details = EmbeddedgetAPI(`https://api.hellosign.com/v3/embedded/sign_url/${signId}`)
    return Details
}

export async function getSignatureId(signature_request_id: string) {
    const Details = EmbeddedgetAPI(`https://api.hellosign.com/v3/signature_request/${signature_request_id}`)
    return Details
}

export async function saveSignatureId(data: any) {
    const Details = postAPI(  REACT_APP_CONTRACTSIGN + '/agreement-details', data)
    return Details
}

export async function getCustomFields(candidateJobId:string) {
    const Details = getAPI( REACT_APP_CONTRACTSIGN + `/contract-custom-fields/${candidateJobId}`)
    return Details
}